import * as actionTypes from './actionTypes';
import { printService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { PrintModel, GeneralModel } from '@app/src/views/StepTwo/channelPublication/models/print';
import { PublicationModel } from '@app/src/views/StepTwo/channelPublication';
import { fetchValidateAccess, fetchValidate } from '@app/src/common/session';

const fetchPrintRequest = () => ({
  type: actionTypes.FETCH_PRINT_REQUEST
});

const fetchPrintSuccess = (id: string) => ({
  type: actionTypes.FETCH_PRINT_SUCCESS,
  id
});

const fetchPrintFailure = () => ({
  type: actionTypes.FETCH_PRINT_FAILURE
});

export const setPrintGeneral = (data: GeneralModel) => ({
  type: actionTypes.SET_PRINT_GENERAL,
  data
});

export const setPrintData = (data: PrintModel) => ({
  type: actionTypes.SET_PRINT_DATA,
  data
});

export const setPrintAllByChannel = (id: string, data: PublicationModel[]) => ({
  type: actionTypes.SET_PRINT_ALL_BY_CHANNEL,
  id,
  data
});

export const deletePrintAllByChannel = (id: number) => ({
  type: actionTypes.DELETE_PRINT_ALL_BY_CHANNEL,
  id
});

export const cleanPrintGeneral = () => ({
  type: actionTypes.CLEAN_PRINT_GENERAL
});

export const clearPrintSummaryId = () => ({
  type: actionTypes.CLEAN_PRINT_SUMMARY_ID
});

export const setPrintExtraWords = (value: any) => ({
  type: actionTypes.SET_PRINT_EXTRAWORDS,
  value
});

export const clearPrintData = () => ({
  type: actionTypes.CLEAR_PRINT_DATA
});

export const fetchPrint = (categoryId: number, json: PrintModel): Function => {
  return async dispatch => {
    dispatch(fetchPrintRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await printService.post(categoryId, json);
      dispatch(fetchPrintSuccess(data[0]['unique_id']));
    } catch (e) {
      dispatch(fetchPrintFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};

export const fetchPrintConsume = (userId: number, categoryId: number, packageId: number, json: PrintModel): Function => {
  return async dispatch => {
    dispatch(fetchPrintRequest());
    await dispatch(fetchValidate());
    try {
      const data = await printService.postPublish(userId, categoryId, packageId, json);
      dispatch(fetchPrintSuccess(data[0]['unique_id']));
    } catch (e) {
      dispatch(fetchPrintFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
